import { useState, useEffect } from "react";
import Card from "@mui/material/Card";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import MDAlert from "components/MDAlert";

// Authentication layout components
import CoverLayout from "layouts/authentication/components/CoverLayout";
import authService from "services/auth-service";

// Video background
import bgVideo from "assets/images/illustrations/Filenders.m4v";

function ForgotPassword() {
  const [isDemo, setIsDemo] = useState(false);
  const [input, setInput] = useState({
    email: "",
  });
  const [error, setError] = useState({
    err: false,
    textError: "",
  });

  const [notification, setNotification] = useState(false);

  const changeHandler = (e) => {
    setInput((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));

    setError({
      err: false,
      textError: "",
    });
  };

  useEffect(() => {
    setIsDemo(process.env.REACT_APP_IS_DEMO === "true");
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const mailFormat = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!input.email.trim().match(mailFormat)) {
      setError({ err: true, textError: "The email must be valid." });
      return;
    }

    try {
      if (!isDemo) {
        await authService.forgotPassword(input.email.trim());
      }
      setNotification(true);
    } catch (err) {
      console.error(err);
      setError({ err: true, textError: err.message || "An error occurred." });
    }
  };

  return (
      <CoverLayout coverHeight="100vh" image={bgVideo}>
        <Card
            sx={{
              width: "100%",
              maxWidth: { xs: "94%", sm: 520, md: 560 },
              mx: "auto",
              borderRadius: "20px",
              boxShadow: "0 20px 60px rgba(0,0,0,0.20)",
              overflow: "visible",
            }}
        >
          <MDBox
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
              mx={2}
              mt={-3}
              py={2}
              mb={1}
              textAlign="center"
          >
            <MDTypography variant="h3" fontWeight="medium" color="white" mt={1}>
              Reset Password
            </MDTypography>
            <MDTypography display="block" variant="button" color="white" my={1}>
              You will receive an e-mail in maximum 60 seconds
            </MDTypography>
          </MDBox>

          <MDBox pt={4} pb={4} px={{ xs: 3, sm: 5 }}>
            <MDBox
                component="form"
                role="form"
                method="POST"
                onSubmit={handleSubmit}
            >
              <MDBox mb={4}>
                <MDInput
                    type="email"
                    label="Email"
                    variant="standard"
                    fullWidth
                    value={input.email}
                    name="email"
                    onChange={changeHandler}
                    error={error.err}
                    InputLabelProps={{ shrink: true }}
                />
              </MDBox>

              {error.err && (
                  <MDTypography variant="caption" color="error" fontWeight="light">
                    {error.textError}
                  </MDTypography>
              )}

              <MDBox mt={6} mb={1}>
                <MDButton variant="gradient" color="info" fullWidth type="submit">
                  reset
                </MDButton>
              </MDBox>
            </MDBox>
          </MDBox>
        </Card>

        {notification && (
            <MDBox mt={3} width="100%" maxWidth="560px" mx="auto">
              <MDAlert color="info" dismissible>
                <MDTypography variant="body2" color="white">
                  {isDemo
                      ? "You can't update the password in the demo version"
                      : "Please check your email to reset your password."}
                </MDTypography>
              </MDAlert>
            </MDBox>
        )}
      </CoverLayout>
  );
}

export default ForgotPassword;